import { ProfileResponse } from 'types/profile';
import { APIConfig, _WalletResponse, _TokenResponse, GasFeeInterface } from '../types';
import APIBase from './apiBase';
import { apiRoutes } from './apiRoutes';

export default class ApiSingWallet extends APIBase {
    constructor(config?: APIConfig, logger?: (arg: string) => void) {
        if (!config) {
            config = {
                apiUrl: process.env.REACT_APP_API
            }
        }

        super(config, logger)
    }

    public async getListWallet(userToken: string): Promise<_WalletResponse> {
        const result = await this.get(
            `${apiRoutes.GET_LIST_WALLET}`,
            {},
            {
                'Authorization': 'Bearer ' + userToken
            }
        )
        return result
    }

    public async getListToken(walletId: string, userToken: string): Promise<_TokenResponse> {
        const result = await this.get(
            `/api/wallets/${walletId}/balance/tokens`,
            {},
            {
                'Authorization': 'Bearer ' + userToken
            }
        )
        return result
    }

    public async getPriceSing(symbol = "SINGUSDT"): Promise<any> {
        const result = await this.get(
            `/queue/price`,
            {
                symbol: symbol,
            }
        )
        return result
    }

    public async getPriceBNB(symbol = "BNBUSDT"): Promise<any> {
        const result = await this.get(
            `/queue/price`,
            {
                symbol: symbol,
            }
        )
        return result
    }

    public async getRatio(symbol): Promise<any> {
        const result = await this.get(
            `/queue/price`,
            {
                symbol: symbol,
            }
        )
        return result
    }

    public async getGasFee(price: number, wallet_id: string, token: string):Promise<GasFeeInterface> {
        const result = await this.post(
            `/nft/gas_fee`,
            {
                price: price,
                wallet_id: wallet_id
            },
            {},
            {
                'Authorization': 'Bearer ' + token
            }
        )
        return result as GasFeeInterface
    }

    public async sendTokens(walletId, encrypted, token: string): Promise<any>{
        const result = await this.post(
            `/api/wallets/${walletId}/token/send`,
            {
                encrypted: encrypted
            },{},
            {
                'Authorization': 'Bearer ' + token
            }
        )
        return result;
    }

    public async sendNft(walletId, encrypted, token: string): Promise<any>{
        const result = await this.post(
            `/api/wallets/${walletId}/nft/send`,
            {
                encrypted: encrypted
            },{},
            {
                'Authorization': 'Bearer ' + token
            }
        )
        return result;
    }

    public async getProfile(token: string): Promise<ProfileResponse>{
        const result = await this.get(
            `/api/profile`,
            {},
            {
                'Authorization': 'Bearer ' + token
            }
        )
        return result;
    }


}